export class BookingAuditEntry {
    constructor(
        public id: string,
        public changes: { [key: string]: any },
        public bookingId: string,
        public userId: string | null,
        public userName: string | null,
        public userEmailAddress: string | null,
        public dateTime: Date
    ) { }
}
